import React from "react";
import { User, Users } from "lucide-react";
import useGetAnalytics from "../hooks/useGetAnalytics";
import Chess from "./../assets/gameicons/2.svg";
import Badminton from "./../assets/gameicons/5.svg";
import Volleyball from "./../assets/gameicons/4.svg";
import Football from "./../assets/gameicons/6.svg";
import Cricket from "./../assets/gameicons/3.svg";
import KhoKho from "./../assets/gameicons/7.svg";
import Kabaddi from "./../assets/gameicons/8.svg";
import Running from "./../assets/gameicons/9.svg";
import Basketball from "./../assets/gameicons/16.svg";
import TableTennis from "./../assets/gameicons/10.svg";
import Yoga from "./../assets/gameicons/11.svg";
import JavelinThorw from "./../assets/gameicons/12.svg";
import DiscusThorw from "./../assets/gameicons/13.svg";
import ShotPut from "./../assets/gameicons/14.svg";
import TugOfWar from "./../assets/gameicons/15.svg";
import RifleShooting from "./../assets/gameicons/17.svg";
import { useEffect } from "react";
import useGetStudentRegistrations from "../hooks/useGetStudentRegistrations";
import GameCard from "../components/GameCard";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const games = [
  { id: "chess", name: "Chess", type: "single", icon: Chess },
  { id: "badminton", name: "Badminton", type: "single", icon: Badminton },
  { id: "volleyball", name: "Volleyball", type: "multi", icon: Volleyball },
  { id: "football", name: "Football", type: "multi", icon: Football },
  { id: "cricket", name: "Cricket", type: "multi", icon: Cricket },
  { id: "kho-kho", name: "Kho-Kho", type: "multi", icon: KhoKho },
  { id: "kabaddi", name: "Kabaddi", type: "multi", icon: Kabaddi },
  { id: "running", name: "Running", type: "single", icon: Running },
  { id: "rifleshooting", name: "Rifle Shooting", type: "single", icon: RifleShooting },
  { id: "basketball", name: "Basketball", type: "multi", icon: Basketball },
  { id: "table-tennis", name: "Table Tennis", type: "single", icon: TableTennis },
  { id: "yoga", name: "Yoga", type: "single", icon: Yoga },
  { id: "javelin-thorw", name: "Javelin Throw", type: "single", icon: JavelinThorw },
  { id: "discus-thorw", name: "Discus Throw", type: "single", icon: DiscusThorw },
  { id: "shot-put", name: "Shot Put", type: "single", icon: ShotPut },
  { id: "tug-of-war", name: "Tug of war", type: "multi", icon: TugOfWar },
];

const BrowseGames = () => {
  const { data: analytics, isLoading } = useGetAnalytics();
  const { data: registrations,isLoading:isRegistrationsLoading } = useGetStudentRegistrations();
  const [allGames, setAllGames] = React.useState(games);
  const [singlePlayerGames, setSinglePlayerGames] = React.useState([]);
  const navigate = useNavigate();
  const [multiPlayerGames, setMultiPlayerGames] = React.useState([]);

  useEffect(() => {
    setSinglePlayerGames(allGames.filter((game) => game.type === "single"));
    setMultiPlayerGames(allGames.filter((game) => game.type === "multi"));
  }, [allGames]);

  useEffect(() => {
    let newGames = allGames;
    if (analytics && analytics.length > 0) {
      newGames = newGames.map((game) => {
        const g = analytics.find((a) => a.game === game.name);

        if (g) return { ...game, registrations: g.count };
        else return game;
      });
    };

    if(registrations && registrations.length > 0) {
      newGames = newGames.map((game) => {
        const g = registrations.find((a) => a.game === game.name);

        if (g) return { ...game, isRegistered: true };
        else return { ...game, isRegistered: false };
      });
    }

    setAllGames(newGames);
  }, [analytics.length,registrations.length]);

  function handleGameClick(game){

    if(registrations?.length >= 3) {
      toast.error("You can only register for a maximum of 3 games")
      return;
    }

    if(game.isRegistered) {
      toast.error("You have already registered for this game")
      return;
    }  

    navigate(`/${game.type === "multi" ? "multiPlayerGame" : "singlePlayerGame"}?game=${game.name}`)

  }

  

  return (
    <div>
      {/* Main Content */}
      <main className="flex-1 container mx-auto px-4 py-8">
        <h1 className="text-center mb-16">
          <span className="text-5xl md:text-7xl font-bold bg-gradient-to-b from-[#190003] to-red-500 bg-clip-text text-transparent animate-gradient-x">
            Game Zone
          </span>
          <div className="text-red-400 text-xl mt-2">Choose Your Adventure</div>
        </h1>

        {/* warning that you can maximum register for 3 games */}
        <div className="bg-red-500 text-white p-4 rounded-lg mb-8">
          <p className="text-lg font-semibold">
            You can register for a maximum of 3 games. Choose wisely!
          </p>
        </div>
        

        {/* Single Player Games */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold mb-4 flex items-center">
            <User className="w-6 h-6 mr-2" />
            Individual Games
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {singlePlayerGames.map((game) => (
              <GameCard onClick={handleGameClick} key={game.id} game={game} isLoading={isLoading|| isRegistrationsLoading} />
            ))}
          </div>
        </section>

        {/* Multiplayer Games */}
        <section>
          <h2 className="text-2xl font-bold mb-4 flex items-center">
            <Users className="w-6 h-6 mr-2" />
            Team Games
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {multiPlayerGames.map((game) => (
              <GameCard onClick={handleGameClick} key={game.id} game={game} isLoading={isLoading || isRegistrationsLoading}/>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
};

export default BrowseGames;
